/**
 * mpClientBrowser — P6-11 create/list/start/fill waits for mpClient.
 */

import {
  WS_MSG,
  createEnvelope,
  encodeMessage
} from '../../domain/net/wsProtocol.js';

function send(state, type, payload) {
  if (!state.socket || state.socket.readyState !== 1) return;
  state.seq += 1;
  state.socket.send(encodeMessage(createEnvelope(type, payload, state.seq)));
}

function rejectWait(wait, code) {
  if (!wait) return;
  if (typeof wait.reject === 'function') {
    wait.reject(new Error(code || 'error'));
  }
}

export function rejectBrowserWaits(state, code) {
  const err = code || 'error';
  if (state.roomWait) {
    clearTimeout(state.roomWait.timer);
    rejectWait(state.roomWait, err);
    state.roomWait = null;
  }
  if (state.listWait) {
    clearTimeout(state.listWait.timer);
    rejectWait(state.listWait, err);
    state.listWait = null;
  }
  if (state.matchWait) {
    clearTimeout(state.matchWait.timer);
    rejectWait(state.matchWait, err);
    state.matchWait = null;
  }
}

/** @returns {boolean} true if message consumed as browser wait */
export function handleBrowserServerMsg(state, env) {
  if (env.type === WS_MSG.ROOM_LIST && state.listWait) {
    clearTimeout(state.listWait.timer);
    state.listWait.resolve(env.payload.rooms || []);
    state.listWait = null;
    return true;
  }
  if (env.type === WS_MSG.ERROR) {
    rejectBrowserWaits(state, env.payload.code || 'error');
    return true;
  }
  return false;
}

function waitWithTimeout(state, key, sendType, payload) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      state[key] = null;
      reject(new Error(`${sendType}_timeout`));
    }, state.welcomeTimeoutMs);
    state[key] = { resolve, reject, timer };
    send(state, sendType, payload);
  });
}

export function listRooms(state) {
  return waitWithTimeout(state, 'listWait', WS_MSG.LIST_ROOMS, {});
}

export function createRoom(state, payload = {}) {
  return waitWithTimeout(state, 'roomWait', WS_MSG.CREATE_ROOM, payload);
}

export function fillBots(state, roomId, targetSize) {
  const payload = { roomId };
  if (targetSize !== undefined && targetSize !== null) {
    payload.targetSize = targetSize;
  }
  return waitWithTimeout(state, 'roomWait', WS_MSG.FILL_BOTS, payload);
}

/** Move self (or omit target) / host may pass targetClientId. */
export function setTeam(state, roomId, team, targetClientId) {
  const payload = { roomId, team };
  if (targetClientId) payload.clientId = targetClientId;
  return waitWithTimeout(state, 'roomWait', WS_MSG.SET_TEAM, payload);
}

export function startMatch(state, roomId) {
  if (state.matchStart) {
    return Promise.resolve(state.matchStart);
  }
  const existing = state.matchWait;
  const promise = new Promise((resolve, reject) => {
    if (existing) {
      const prevResolve = existing.resolve;
      const prevReject = existing.reject;
      existing.resolve = (value) => {
        prevResolve(value);
        resolve(value);
      };
      existing.reject = (err) => {
        if (typeof prevReject === 'function') prevReject(err);
        reject(err);
      };
      return;
    }
    const timer = setTimeout(() => {
      state.matchWait = null;
      reject(new Error('start_match_timeout'));
    }, state.matchStartTimeoutMs);
    state.matchWait = { resolve, reject, timer };
  });
  send(state, WS_MSG.START_MATCH, { roomId });
  return promise;
}
